import React from 'react';
import { useParams } from 'react-router-dom';

// Import all wedding design templates
import PassportWedding from './designs/PassportWedding.jsx';
import FloralWedding from './designs/FloralWedding.jsx';
// Add more designs here as you create them
// import MinimalistWedding from './designs/MinimalistWedding.jsx';
// import RusticWedding from './designs/RusticWedding.jsx';

const WeddingInvitation = () => {
  const { designType, coupleNames } = useParams();

  // Map design types to components
  const designs = {
    passport: PassportWedding,
    floral: FloralWedding,
    // Add more designs here
    // minimalist: MinimalistWedding,
    // rustic: RusticWedding,
  };

  // Get the design component or default to passport
  const DesignComponent = designs[designType?.toLowerCase()] || PassportWedding;

  return <DesignComponent coupleNames={coupleNames} />;
};

export default WeddingInvitation;
